export interface BackgroundTaskSubscriptionRequest {
    SubscriptionEvents: BackgroundTaskSubscriptionEvents;
    SubscriptionChannel: BackgroundTaskSubscriptionChannels;
}

export enum BackgroundTaskSubscriptionEvents {
    None = "None",
    BackgroundTaskFailed = "BackgroundTaskFailed",
    BackgroundTaskStopped = "BackgroundTaskStopped",
    BackgroundTaskStepCompleted = "BackgroundTaskStepCompleted",
}

export enum BackgroundTaskSubscriptionChannels {
    Slack = "Slack",
}

export const DefaultBackgroundTaskSubscription: BackgroundTaskSubscriptionRequest = {
    SubscriptionEvents: BackgroundTaskSubscriptionEvents.BackgroundTaskStopped,
    SubscriptionChannel: BackgroundTaskSubscriptionChannels.Slack,
}
